module.exports = __webpack_public_path__ + "img/tddg-8.f392bb72.jpg";